import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ref, onValue,update } from "firebase/database"; // Firebase Realtime Database
import db from "./FireBase/firebase"; // Instance Firebase

import Donnees from "./Components/donnees";
import Compteur from "./Components/compteur";
import Header from "./Components/header";
import Thermometre from "./Components/temperature";
import CarMap from "./Components/map";
import Mesure from "./Components/mesure";
import FirebaseChart from "./Components/graphique";

const App = () => {
  const [showCompteur, setShowCompteur] = useState(true);
  const [showDonnees, setShowDonnees] = useState(false);
  const [showTemperature, setShowTemperature] = useState(true);
  const [paramMesures, setParamMesures] = useState([]); 
  const [paramGraph, setParamGraph] = useState([]);
  const [points, setPoints] = useState([]);
  const collectionName = localStorage.getItem("collectionName") || "/data";

  
  useEffect(() => {
    const paramRef = ref(db, "parametres/mesures");
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const fetchedMesures = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const data = childSnapshot.val();
          if (data.visible) { 
            fetchedMesures.push({ id: key, ...data });
          }
        });
        setParamMesures(fetchedMesures);
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );
  
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const paramRef = ref(db, "parametres/graphes");
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const fetchedMesures = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const data = childSnapshot.val();
          if (data.visible) { 
            fetchedMesures.push({ id: key, ...data });
          }
        });
        setParamGraph(fetchedMesures);
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );
  
    return () => unsubscribe();
  }, []);

  
  useEffect(() => {
    const pointsRef = ref(db, collectionName);
    const unsubscribe = onValue(
      pointsRef,
      (snapshot) => {
        const fetchedData = [];
        snapshot.forEach((childSnapshot) => {
          fetchedData.push({
            id: childSnapshot.key,
            ...childSnapshot.val(),
          });
        });

        if (fetchedData.length > 0) {
          setPoints(fetchedData);
        }
      },
      (error) => {
        console.error("Error fetching data: ", error);
      }
    );

    return () => unsubscribe();
  }, [collectionName]);

  function modifEtatVisible(id, visible, path) {
    const pathDB = path + id;
    const paramRef = ref(db, pathDB);
    update(paramRef, { visible: visible }).catch((error) => {
      console.error("Erreur lors de la mise à jour de Firebase : ", error);
    });
  }

  const toggleCompteur = () => setShowCompteur(!showCompteur);
  const toggleDonnees = () => setShowDonnees(!showDonnees);
  const toggleTemperature = () => setShowTemperature(!showTemperature);
  const toggleMesure = (id, visible) => modifEtatVisible(id, visible,"parametres/mesures/");
  const toggleGraphe = (id, visible) => modifEtatVisible(id, visible,"parametres/graphes/");

  return (
    <React.StrictMode>
      <Header
        toggleCompteur={toggleCompteur}
        toggleDonnees={toggleDonnees}
        toggleTemperature={toggleTemperature}
        toggleMesure={toggleMesure}
        toggleGraphe={toggleGraphe}
      />

      {showDonnees && <Donnees />}
      {showCompteur && <Compteur />}
      {showTemperature && <Thermometre />}

     
      {paramMesures.map(({ id, field, x, y, visible, seuilMin, seuilMax }) => (
        visible && <Mesure key={id} field={field} x={x} y={y} seuilMin={seuilMin} seuilMax={seuilMax} id={id}/>
      ))}

      <div className="grid-container">
        {paramGraph.map(({ id, field, visible }) => (
          visible ? (
            <div className="chart-item" key={id} id={id}>
              <FirebaseChart field={field} />
            </div>
          ) : null
        ))}
      </div>




      <div style={{ height: "30vh", width: "30%" }}>
        <CarMap points={points} />
      </div>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();